import React from 'react';
import Label from 'shared/components/label';
import BaseStep from 'shared/registration/components/steps/base-step';
import placeholders from 'src/static/placeholders.json';
import {useFormikContext} from 'formik';
import {UnverifiedMobileNumberForm} from 'src/types/onboarding';
import TextInput from 'src/components/inputs/text-input';

export default function UnverifiedMobileNumber() {
  const form = useFormikContext<UnverifiedMobileNumberForm>();

  return (
    <BaseStep stepHeader="What's your phone number?" step>
      <Label>
        Mobile Number
        <TextInput
          {...form.getFieldProps('mobile')}
          autoFocus
          placeholder={placeholders.tel}
          autoComplete="tel"
          aria-label="Mobile Number"
          aria-describedby="stepHeader"
          error={form.errors?.mobile}
          cy="mobile"
        />
      </Label>
    </BaseStep>
  );
}
